import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.scss';
import App from './App';
import { captureAppReleaseFromLocation } from './utils/appRelease';
import { captureIncomingCallFromLocation } from './utils/incomingCallLink';
import { captureNativePushTokenFromLocation } from './utils/nativePush';
import { registerPushServiceWorker } from './utils/registerPushServiceWorker';
import { markSearchCrawler } from './utils/searchCrawler';

captureAppReleaseFromLocation();
captureIncomingCallFromLocation();
captureNativePushTokenFromLocation();
markSearchCrawler();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerPushServiceWorker();


